import React, { FC } from 'react';
import Icons from './Icons';
import '../../../lib/css/rib.css';
import bankImg from '../../../lib/images/credit-mutuel.svg';
import { getHostApi } from '../../utils';
import { getUserId } from './MonCompteAction';

interface Props {
  note: string;
}

const Rib: FC<Props> = ({ note }): JSX.Element => {

  return (
    <div>
      <div className='rib-img-container'>
        <img src={bankImg} alt="bank" className="rib-img" />
        <div className='rib-bold'>RELEVE D'IDENTITE BANCAIRE</div>
      </div>
      <div>Identifiant national de compte bancaire - RIB</div>
      <div className='rib-container'>
        <div className='rib-item rib-border'>
          <div className='rib-info'>
            <div className='rib-item'>
              <div>Banque</div>
              <div className='rib-bold'>10278</div>
            </div>
            <div className='rib-item'>
              <div>Guichet</div>
              <div className='rib-bold'>02141</div>
            </div>
            <div className='rib-item'>
              <div>N° de compte</div>
              <div className='rib-bold'>00020322701</div>
            </div>
            <div className='rib-item'>
              <div>Clé</div>
              <div className='rib-bold'>43</div>
            </div>
            <div className='rib-item'>
              <div>Devise</div>
              <div className='rib-bold'>EUR</div>
            </div>
          </div>
        </div>

        <div className='rib-item rib-bank-name rib-border'>
          <div className='rib-bold'>CCM VIRE</div>
        </div>
      </div>

      <div>Identifiant international de compte bancaire</div>
      <div className='rib-container'>
        <div className='rib-item rib-border'>
          <div>
            <div>IBAN (International Bank Account Number)</div>
            <div className='rib-iban-container'>
              <div className='rib-bold rib-item'>FR76</div>
              <div className='rib-bold rib-item'>1027</div>
              <div className='rib-bold rib-item'>8021</div>
              <div className='rib-bold rib-item'>4100</div>
              <div className='rib-bold rib-item'>0203</div>
              <div className='rib-bold rib-item'>2270</div>
              <div className='rib-bold rib-item'>143</div>
            </div>
          </div>
        </div>

        <div className='rib-item rib-bank-name rib-border'>
          <div className='rib-bic-container'>
            <div>BIC (Bank Identifier Code)</div>
            <div className='rib-bold'>CMCIFR2A</div>
          </div>
        </div>
      </div>

      <div className='rib-container rib-address'>
        <div className='rib-item rib-address-margin'>
          <div className='rib-bold'>Domiciliation</div>
          <div>CCM VIRE</div>
          <div>25 RUE GENERAL LECLERC</div>
          <div>14500 VIRE</div>
        </div>

        <div className='rib-item rib-address-margin'>
          <div className='rib-bold'>Titulaire du compte (Account Owner)</div>
          <div>DESIGN'PARTNER</div>
          <div>LIEU DIT LA PAPILLONNIERE</div>
          <div>14500 VIRE</div>
        </div>
      </div>

      {note &&
        <div>
          <p>{note}</p>
        </div>
      }
      <div>
        <p className="text-center mt-4">
          <a target='_blank' href={`${getHostApi()}/customers/${getUserId()}/rib.pdf?xsrf=${localStorage.getItem('xsrfToken')}`} className="cursor-pointer border border-dark p-2 printButton">
            <Icons icon="print" size={16} color="#333" />
            <span className="pl-1">Imprimer le RIB</span>
          </a>
        </p>
      </div>
    </div>
  );
}

export default Rib;
